<template lang="pug">
div
  AlgoliaWrapper(:search-context='dealerLocatorInternational')
    div(class='px-3 bg-gray-lighter')
      div(class='lg:container py-5')
        h1(class='text-center mt-0') Find an International Dealer

        div(class='mx-auto w-full lg:max-w-md space-y-3 text-center')
          DealerLocatorCountrySelector

          UniversalLink(
            link='/dealer-locator'
            class='relative inline-block text-action font-bold ml-3 pr-6'
            has-color-override
          )
            span(class='block triangle triangle-thick') or Search USA Dealers

    div(class='p-3')
      div(class='lg:container')
        AlgoliaResults
          template(#results='{ results }')
            div(class='pb-4 mb-6 border-b border-black')
              p(class='max-w-md') #[span(class='text-danger-dark font-bold') Please note:] Not all dealers stock inventory. Please call dealer to confirm product availability.

            ul(class='grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-10')
              template(v-for='(result, index) in results' :key='index')
                li(class='flex gap-x-2')
                  div(class='flex-none')
                    div(
                      class='flex justify-center items-center w-9 h-9 rounded-full bg-danger-dark text-white font-bold leading-none'
                    ) {{ index + 1 }}
                  div(class='flex-1')
                    DealerLocatorDealer(:key='result.objectID' :dealer='result' is-international)

        div(v-if='!isLoading && results.length == 0')
          p Sorry, there are no locations within your search area. Please try refining your search.
</template>

<script>
export default defineNuxtComponent({
  setup() {
    const { $algolia } = useNuxtApp()
    const { translateTemplate } = useTemplateTranslator()

    // Set SearchProvider here so we don't have to do $algolia.searchContexts everywhere
    const dealerLocatorInternational = $algolia.searchContexts.dealerLocatorInternational

    useMetaTags({
      title: translateTemplate('International Dealer Locator [TITLE_SUFFIX]'),
    })

    return {
      dealerLocatorInternational,
    }
  },
  data() {
    return {
      selectedCountry: '',
      isLoading: true,
    }
  },
  watch: {
    selectedCountry(newVal) {
      // If no country then early out
      if (!newVal) return

      this.search()
    },
  },
  methods: {
    async search() {
      // The isInternational flag is applied to true at the index level
      await this.dealerLocatorInternational.search()
      this.isLoading = false
    },
  },
})
</script>
